import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { useApp } from "../../AppContext/AppContext";
import dropUp from '../../../public/assets/drop-up.png'; // Adjust the path as necessary
import dropDown from '../../../public/assets/drop-down.png'; 
const Navbar = () => {
  const { handleAppSelect, selectedApp } = useApp();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isScrolling, setIsScrolling] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeDropdownItem, setActiveDropdownItem] = useState(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const reloadPage = () => {
    window.location.href = window.location.origin + window.location.pathname;
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      setIsScrolling(true);
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
      setActiveSection(sectionId);
    }
    setMenuOpen(false);
    setIsDropdownOpen(false); // Close dropdown when navigating
  };

  const toggleDropdown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (window.innerWidth <= 1200) {
      setIsDropdownOpen((prev) => !prev);
    }
  };

  const handleMouseEnter = () => {
    if (window.innerWidth > 1200) {
      setIsDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 1200) {
      setIsDropdownOpen(false);
    }
  };

  const handleDropdownSelect = (app) => {
    setActiveDropdownItem(app);
    handleAppSelect(app);
    setIsDropdownOpen(false);
    setMenuOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    setActiveSection('home');
  };

  useEffect(() => {
    let scrollTimeout;

    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const sections = ['home', 'features', 'supported-sites', 'instructions', 'faqs'];
        const scrollPosition = window.scrollY + 100;

        for (const section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const offsetTop = element.offsetTop - 100;
            const height = element.offsetHeight;

            if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
              setActiveSection(section);
              break;
            }
          }
        }
        setIsScrolling(false);
      }, 100);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, [isScrolling]);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo" onClick={reloadPage}>
          <img className="logo" src="/assets/nav-Icon.png" alt="All Video Downloader Logo" style={{ cursor: 'pointer' }} />
        </div>
        <button className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? "✖" : <img className="nav-menu-icon" src="./assets/nav-menu.png"/>}
        </button>
        <div className={`nav-items ${menuOpen ? "open" : ""}`}>
          <a 
            onClick={reloadPage} 
            className={`nav-item ${activeSection === 'home' ? 'active' : ''}`}
          >
            Home
          </a>
          <a 
            onClick={() => scrollToSection('instructions')} 
            className={`nav-item ${activeSection === 'instructions' ? 'active' : ''}`}
          >
            How to Use?
          </a>
          {(!selectedApp || selectedApp === 'All Video Downloader') && (
            <a 
              onClick={() => scrollToSection('features')} 
              className={`nav-item ${activeSection === 'features' ? 'active' : ''}`}
            >
              Our Features
            </a>
          )}
          <div className="dropdown"
            onClick={toggleDropdown}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <a href="#downloader" className={`nav-item ${activeDropdownItem ? 'active' : ''}`}>
              Others Downloaders
              <img 
                src={isDropdownOpen ? dropUp : dropDown} 
                alt="Dropdown Arrow" 
                className="dropdown-arrow" 
              />
            </a>
            <div className={`dropdown-content ${isDropdownOpen ? 'show' : ''}`}>
              <a 
                onClick={() => handleDropdownSelect('Instagram')}
                className={activeDropdownItem === 'Instagram' ? 'active' : ''}
              >
                Instagram
              </a>
              <a 
                onClick={() => handleDropdownSelect('Facebook')}
                className={activeDropdownItem === 'Facebook' ? 'active' : ''}
              >
                Facebook
              </a>
              <a 
                onClick={() => handleDropdownSelect('Tiktok')}
                className={activeDropdownItem === 'Tiktok' ? 'active' : ''}
              >
                TikTok
              </a>
            </div>
          </div>
          <a 
            onClick={() => scrollToSection('supported-sites')} 
            className={`nav-item ${activeSection === 'supported-sites' ? 'active' : ''}`}
          >
            Supported Sites
          </a>
          <a 
            onClick={() => scrollToSection('faqs')} 
            className={`nav-item ${activeSection === 'faqs' ? 'active' : ''}`}
          >
            FAQs
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;